import { render } from "./CreatePostAuth.vue?vue&type=template&id=4ac9d1c8"
import script from "./CreatePostAuth.vue?vue&type=script&lang=js"
export * from "./CreatePostAuth.vue?vue&type=script&lang=js"

import "./CreatePostAuth.vue?vue&type=style&index=0&id=4ac9d1c8&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__